import {
  retrieveApproachingStatutesReport,
  type RetrieveApproachingStatutesReportInput,
} from "@/lib/data/requests/reports/reports-approaching-statutes-report";
import { queryKeys } from "@/lib/data/static";

export const retrieveApproachingStatutesReportQueryOptions = (
  filters: RetrieveApproachingStatutesReportInput,
) => ({
  queryKey: [queryKeys.reports, "approaching-statutes", filters],
  queryFn: () => retrieveApproachingStatutesReport(filters),
});
